import { useVenue } from 'Shared/VenueProvider';
import {createContext,useContext,onCleanup} from 'solid-js';
import { resolveStyleDetails } from 'Shared/frontend/widgets/Styles';

export interface PathElement {
	key: string|number;
	classes?: string[];
	childKey?: string|number;
}

export const ChildKeyContext = createContext<() => string|number|undefined>(() => undefined);

export function useChildKey() {
	return useContext(ChildKeyContext);
}

interface IStylesContent {
	path: PathElement[]|null;
	styleDetails: ()=>IStyleDetails[];
	setStyleDetails?: (details:IStyleDetails[])=>void,
	atTop: () => boolean,

	/* Just used by OuterBasic.tsx */
	deferredClasses?: ()=>string[],
	setDeferredClasses?: ((func:()=>string[]) => void)
};

export interface IStyleDetails {
	tag: string;
	pathWhenAdded: (string|number)[];
	rules: {
		settings: XXX,
		css: YYY
	}[];
};


const StylesContext = createContext();

export function StylesProvider(P:{children} & IStylesContent)
{
	return (
		<StylesContext.Provider value={P}>
			{P.children}
		</StylesContext.Provider>
	);
}

export function useStyleDetails(): (()=>IStyleDetails[])
{
	return useContext(StylesContext).styleDetails ?? (() => []);
}

export function useStylePath(): PathElement[]
{
	return useContext(StylesContext).path;
}

export function useAtTop(): (() => boolean)
{
	return useContext(StylesContext).atTop;
}

export function initPageStyles(data)
{
	const ctx = useContext(StylesContext);

	const trimmedParentStyles = (useVenue().styles ?? []).filter(e => !(data.removeStyles ?? []).includes((e as any)?.type ?? e));

	const combinedStyleTags = [...trimmedParentStyles, ...(data.styles ?? [])];
	const styleDetails = resolveStyleDetails([],combinedStyleTags);

	ctx.setStyleDetails(styleDetails);
	ctx.setDeferredClasses(data.classes);

	onCleanup(() => {
		ctx.setStyleDetails([]);
		ctx.setDeferredClasses([]);
	});
}

/* Just used by OuterBasic.tsx */
export function useDeferredClasses(): (()=>string[])
{
	return useContext(StylesContext).deferredClasses;
}


